export default "__VITE_ASSET__DmO5Ge0M__"